import React, { useCallback, useEffect, useState } from 'react';
import { TicketsService } from '../services/ticketsService';
import type { Ticket } from '../types/ticket';
import TicketCard from './TicketCard';

interface MyTicketsViewProps {
  /** Cambia para forzar recarga (p.ej. tras crear un ticket). */
  reloadKey?: number;
}

const MyTicketsView: React.FC<MyTicketsViewProps> = ({ reloadKey }) => {
  const [tickets, setTickets] = useState<Ticket[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      setTickets(await TicketsService.mine());
    } catch (err) {
      setError((err as Error).message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    void load();
  }, [load, reloadKey]);

  if (loading) {
    return (
      <div className="flex items-center justify-center py-12">
        <div className="w-8 h-8 rounded-full border-2 border-[#334155] border-t-[#1f9e3f] animate-spin" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="p-4 rounded-lg bg-red-900/40 border border-red-500/50 text-red-300 text-sm">
        {error}
      </div>
    );
  }

  if (tickets.length === 0) {
    return (
      <div className="text-center py-12 text-[#94a3b8]">
        <p>Todavía no has abierto ninguna petición.</p>
      </div>
    );
  }

  return (
    <div className="space-y-3">
      {tickets.map((t) => (
        <TicketCard key={t.id} ticket={t} />
      ))}
    </div>
  );
};

export default MyTicketsView;
